import { render, staticRenderFns } from "./PaymentShipper.vue?vue&type=template&id=786559d6&scoped=true"
import script from "./PaymentShipper.vue?vue&type=script&lang=js"
export * from "./PaymentShipper.vue?vue&type=script&lang=js"
import style0 from "./PaymentShipper.vue?vue&type=style&index=0&id=786559d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786559d6",
  null
  
)

export default component.exports